import Mutations from '../../odata/mutations';

export default { ...new Mutations('vehiclePart'), ...new Mutations('vehicleParts') };
